import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import moment from 'moment';
import { AppContext } from '../AppContext';
import { tre } from '../trebus';

const TripCollectingModal = ({ show, handleClose, traveller }) => {
    const context = useContext(AppContext);
    const [pendingPayments, setPendingPayments] = useState([]);
    const [confirmModal, setConfirmModal] = useState({ show: false, paymentId: null });

    useEffect(() => {
        if (show && traveller?.user?.id) {
            tre.api('GET', `/users/${traveller.user.id}/payments`, {
                context: context,
                params: {
                    status: 'NOT_PAID'
                },
                success: (response) => {
                    setPendingPayments(response.data || []);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, traveller]);

    const handleCollectPayment = (paymentId) => {
        setConfirmModal({ show: true, paymentId });
    };

    const confirmCollectPayment = () => {
        const paymentId = confirmModal.paymentId;
        tre.api('PUT', `/payments/${paymentId}/collect`, {
            context: context,
            success: () => {
                setPendingPayments(pendingPayments.filter(p => p.id !== paymentId));
                setConfirmModal({ show: false, paymentId: null });
            }
        });
    };

    const closeConfirmModal = () => {
        setConfirmModal({ show: false, paymentId: null });
    };
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Cobrar Viaje</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ListGroup>
                        {pendingPayments.length > 0 ? (
                            pendingPayments.map(payment => (
                                <ListGroup.Item 
                                    key={payment.id}
                                    className="d-flex justify-content-between align-items-center"
                                >
                                    <div>
                                        <div className="fw-bold">{payment.concept}</div>
                                        <div className="text-muted small">
                                            Fecha: {moment(payment.created_at).format('DD-MM-YYYY')}
                                        </div>
                                        <div className="text-primary">
                                            Importe: {Number(payment.price).toFixed(2)}€
                                        </div>
                                    </div>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={() => handleCollectPayment(payment.id)}
                                    >
                                        Cobrar
                                    </Button>
                                </ListGroup.Item>
                            ))
                        ) : (
                            <ListGroup.Item className="text-center text-muted">
                                No hay pagos pendientes
                            </ListGroup.Item>
                        )}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={confirmModal.show} onHide={closeConfirmModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Cobro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Estás seguro de que deseas marcar este pago como cobrado?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeConfirmModal}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={confirmCollectPayment}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default TripCollectingModal;
